import React, { Component } from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import GithubRepoCard from "../../components/githubRepoCard/GithubRepoCard";
import Button from "../../components/button/Button";
import TopButton from "../../components/topButton/TopButton";
import { Fade } from "react-reveal";
import {
  greeting,
  projectsHeader,
} from "../../portfolio.js";
import ProjectsData from "../../shared/opensource/projects.json";
import projectsdesign from "../../shared/opensource/projectsdesign.json";
import "./Projects.css";
import ProjectsImg from "./ProjectsImg";
import DesignProjectCard from "../../components/desinRepoCard/DesignProjectCard";

class Projects extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false,
      modalImage: null
    };
  }

  openModal = (imageSrc) => {
    this.setState({
      modalOpen: true,
      modalImage: imageSrc
    });
  };

  closeModal = () => {
    this.setState({
      modalOpen: false,
      modalImage: null
    });
  };

  render() {
    const theme = this.props.theme;
    const { modalOpen, modalImage } = this.state;

    return (
      <div className="projects-main">
        <Header theme={theme} />

        <div className="basic-projects">
          <Fade bottom duration={2000} distance="40px">
            <div className="projects-heading-div">
              <div className="projects-heading-img-div">
                <ProjectsImg theme={theme} />
              </div>
              <div className="projects-heading-text-div">
                <h1
                  className="projects-heading-text"
                  style={{ color: theme.text }}
                >
                  {projectsHeader.title}
                </h1>
                <p
                  className="projects-header-detail-text subTitle"
                  style={{ color: theme.secondaryText }}
                >
                  {projectsHeader["description"]}
                </p>
              </div>
            </div>
          </Fade>
        </div>

        <div className="publications-heading-text-div">
          <h1
            className="publications-heading-text"
            style={{ color: theme.text }}
          >
            My Development Projects
          </h1>
          <p
            className="projects-header-detail-text subTitle"
            style={{ color: theme.secondaryText }}
          >
            Here is a selection of projects I have designed and developed, reflecting my expertise and my ability to turn ideas into practical and innovative solutions.
          </p>
        </div>

        <div className="repo-cards-div-main">
          {ProjectsData.data.map((repo) => {
            return <GithubRepoCard key={repo.id} repo={repo} theme={theme} openModal={this.openModal} />;
          })}
        </div>

        <Button
          text={"More Projects"}
          className="project-button"
          href={greeting.githubProfile}
          newTab={true}
          theme={theme}
        />

        <div className="projects-heading-text-div">
          <h1
            className="projects-heading-text"
            style={{ color: theme.text }}
          >
            My Design & UI/UX Projects
          </h1>
          <p
            className="projects-header-detail-text subTitle"
            style={{ color: theme.secondaryText }}
          >
            Here is a selection of projects I have worked on, showcasing my skills in design and UI/UX, and my ability to create intuitive, user-friendly, and visually appealing digital experiences
          </p>
        </div>

        <div className="repo-cards-div-main">
          {projectsdesign.data.map((repo) => {
            return <DesignProjectCard key={repo.id} repo={repo} theme={theme} openModal={this.openModal} />;
          })}
        </div>

        {/* Image Modal */}
        {modalOpen && (
          <div className="image-modal" onClick={this.closeModal}>
            <div className="modal-content">
              <span className="modal-close">&times;</span>
              <img src={modalImage} alt="Full size" className="modal-image" />
            </div>
          </div>
        )}

        <Footer theme={this.props.theme} onToggle={this.props.onToggle} />
        <TopButton theme={this.props.theme} />
      </div>
    );
  }
}

export default Projects;